module.exports = __webpack_public_path__ + "static/DINWeb-8daf4116fe83c7fa36454950832563e0.eot";